/**
 * @generated SignedSource<<25e7799fa7529ad97ed5e9ee7964aa54>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type NotificationChannel = "EMAIL" | "PUSH" | "SMS";
export type SetUserNotificationPreferencesInput = {
  preferences: NotificationPreferencesChannelsInput;
  userId: string;
};
export type NotificationPreferencesChannelsInput = {
  bookingReminders: ReadonlyArray<NotificationChannel | null | undefined>;
  bookingUpdates: ReadonlyArray<NotificationChannel | null | undefined>;
  eventReminders: ReadonlyArray<NotificationChannel | null | undefined>;
  eventUpdates: ReadonlyArray<NotificationChannel | null | undefined>;
  requestedTimeAvailable: ReadonlyArray<NotificationChannel | null | undefined>;
};
export type useSetUserNotificationPreferencesMutation$variables = {
  input: SetUserNotificationPreferencesInput;
};
export type useSetUserNotificationPreferencesMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly success: boolean;
  } | null | undefined;
};
export type useSetUserNotificationPreferencesMutation = {
  response: useSetUserNotificationPreferencesMutation$data;
  variables: useSetUserNotificationPreferencesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSetUserNotificationPreferencesMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "SetUserNotificationPreferencesPayload",
        "kind": "LinkedField",
        "name": "setUserNotificationPreferences",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSetUserNotificationPreferencesMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "SetUserNotificationPreferencesPayload",
        "kind": "LinkedField",
        "name": "setUserNotificationPreferences",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4ca15eb302b9ed1765d6582fd10fb039",
    "id": null,
    "metadata": {},
    "name": "useSetUserNotificationPreferencesMutation",
    "operationKind": "mutation",
    "text": "mutation useSetUserNotificationPreferencesMutation(\n  $input: SetUserNotificationPreferencesInput!\n) {\n  responsePayload: setUserNotificationPreferences(input: $input) {\n    success\n    errors {\n      __typename\n      code\n      message\n      field\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a50ef8a2e86793513b4acb5185b3547e";

export default node;
